/**
 * @desc 订单详情
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(
  params: API.omsFlow.systemOrderFacadeImpl.getOrderItemDetail.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/rpc/omsflow/getOrderItemDetail`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
